import React, { useEffect, useState } from 'react';

function ProfileList() {
  const [profiles, setProfiles] = useState([]);


  useEffect(() => {
    fetch('/profile/list-profiles')
      .then((response) => response.json())
      .then((data) => setProfiles(data))
      .catch((error) => console.error(error));
  }, []);

  const handleDelete = async (profileId) => {
    try {
      const response = await fetch(`/profile/delete-profile/${profileId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error('La suppression du profil a échoué.');
      }

      console.log('Profil supprimé avec succès.');
      // Actualiser la liste des profils après la suppression réussie
      setProfiles(profiles.filter((profile) => profile._id !== profileId));
    } catch (error) {
      console.error('Erreur lors de la suppression du profil:', error.message);
    }
  };

  return (
    <section>
      <div className="list_profile">
        {profiles.map((profile) => (
          <div className="profil" key={profile._id}>
            <a href={`/profile/${profile._id}`}>
              <div
                className="image_profile"
                style={{ backgroundImage: `url(${profile.url})` }}
              ></div>
            </a>
            <h3 className="nom_profile">{profile.nom}</h3>
            <button className="btn-delete" onClick={() => handleDelete(profile._id)}>Supprimer</button>
          </div>
        ))}
      </div>
    </section>
  );
}

export default ProfileList;
